import { navigate as gatsbyNavigate } from "gatsby";

const navigate = (path, options = {}, language) => {
	const lang = language || window.__LANGUAGE;
	gatsbyNavigate(lang !== "en" ? path : `/en${path === "/" ? "" : path}`, options);
};

export default navigate;